import type {
  IGenericFormPayload,
  IWMSResponse,
  TTemplateName,
} from '~/interfaces/form/formBuilder';

export const useFormService = () => {
  const { $fetch } = useNuxtApp();
  const settings = useSiteStore();

  const fetchForm = async (
    templateName: TTemplateName,
  ): Promise<IWMSResponse> => {
    try {
      return await $fetch<IWMSResponse>(
        `cron/forms/jackpotcity/${settings.getRegionCode}/${templateName}`,
        {
          base: 'config',
          headers: { 'Content-Type': 'text/plain' },
          query: { 'api-version': 2 },
        },
      );
    } catch (e) {
      console.error(e);
    }
  };

  const postGenericForm = async ({
    payload,
    useAuth = false,
  }: {
    payload: IGenericFormPayload;
    useAuth?: boolean;
  }) => {
    try {
      return await $fetch('api/v1/Forms', {
        method: 'POST',
        base: 'base',
        body: { ...payload, brand: 'JackpotCity' } as IGenericFormPayload,
        useAuthentication: useAuth,
      });
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  return {
    fetchForm,
    postGenericForm,
  };
};
